import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  // Anonymous (guest) sessions are created for The R0 Twenty only - they must not
  // unlock the member area (dashboard, exams, Ask Rio, study notes).
  const isGuest = !!(session?.user as any)?.is_anonymous;

  if (!session || isGuest) {
    // Preserve the current URL so user returns here after login (never re-wrap /login)
    const currentPath = `${location.pathname}${location.search}`;
    const redirect = location.pathname.startsWith('/login') ? '/dashboard' : currentPath;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }



  return <>{children}</>;
}
